module.exports = __webpack_public_path__ + "img/star-icon.4d4528f1.svg";